import t from"../../utils/biggestInstallmentPlanAsBest.js";const s=(s,a)=>{const e=Object.assign({},a.data.item);t(e),a.data=Object.assign(Object.assign({},a.data),{item:e})};export{s as default};
